<template>
   <BaseLayout
    :panels="panels"
    :gutter="10"
    :padding="10"
    style="background:var(--bg2);border-left:1px solid var(--border)"
    >
    </BaseLayout>


</template>

<script>
export default {
  data() {
    return {
      status: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.get('admin/status').then((res)=>{
        this.status =res.data.data;
      });
    },
  },
  computed: {
    links() {
      return [{
        name: '腾讯云',
        url: 'https://cloud.tencent.com/',
      }, {
        name: 'Github',
        url: 'https://www.github.com',
      },
      {
        name: 'knexjs',
        url: 'https://www.knexjs.org',
      }];
    },
    panels() {
      return [{
        x: 0, y: 0, w: 18, h: 6, control: 'PanelSystemStatus', data: this.status.system,
      }, {
        x: 18, y: 0, w: 6, h: 6, control: 'PanelRiskStatus', data: this.status.risk,
      }, {
        x: 18, y: 6, w: 6, h: 5, control: 'PanelLinkList', data: this.links,
      }, {
        x: 0, y: 6, w: 4.5, h: 5, control: 'PanelClientStatus', data: this.status.server,
      },
      {
        x: 4.5, y: 6, w: 4.5, h: 5, control: 'PanelServerStatus', data: this.status.server,
      },
      {
        x: 9, y: 6, w: 4.5, h: 5, control: 'PanelRedisStatus', data: this.status.redis,
      },
      {
        x: 13.5, y: 6, w: 4.5, h: 5, control: 'PanelDbStatus', data: this.status.db,
      },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
